import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=b1017f54&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1017f54')) {
      api.createRecord('b1017f54', component.options)
    } else {
      api.reload('b1017f54', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=b1017f54&", function () {
      api.rerender('b1017f54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-287ro39aj7S7n/JS/comp/FavElement.vue"
export default component.exports